class PaginationChange extends HTMLElement {
  constructor () {
    super()

    this.elements = {
      nextTrigger: this.querySelector(
        '[data-pagination-change-el="next-trigger"]',
      ),
      prevTrigger: this.querySelector(
        '[data-pagination-change-el="prev-trigger"]',
      ),
    }

    this.state = {
      root: window.theme.tagalys.results.stateLayer.state,
    }

    this._boundHandlers = {
      handleProductsUpdated: products => {
        if (products.length > 0) {
          this.render()
        } else {
          this.hidden = true
        }
      },
      handleSortUpdated: () => {
        this._lowestCurrentPage = 1
        this._highestCurrentPage = 1
      },
      handleNextClick: e => {
        e.preventDefault()
        window.theme.tagalys.results.eventBus.publish(
          'results:ui:pagination:changed',
          { page: e.currentTarget.dataset.page },
        )
      },
      handlePrevClick: e => {
        e.preventDefault()
        window.theme.tagalys.results.eventBus.publish(
          'results:ui:pagination:changed',
          { page: e.currentTarget.dataset.page },
        )
      },
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
    this.elements.nextTrigger?.addEventListener(
      'click',
      this._boundHandlers.handleNextClick,
    )
    this.elements.prevTrigger?.addEventListener(
      'click',
      this._boundHandlers.handlePrevClick,
    )
  }

  disconnectedCallback () {
    this.unsubscribeFromEvents()
    this.elements.nextTrigger?.removeEventListener(
      'click',
      this._boundHandlers.handleNextClick,
    )
    this.elements.prevTrigger?.removeEventListener(
      'click',
      this._boundHandlers.handlePrevClick,
    )
  }

  subscribeToEvents () {
    window.theme.tagalys.results.eventBus.subscribe(
      'results:state:products:updated',
      this._boundHandlers.handleProductsUpdated,
    )
    window.theme.tagalys.results.eventBus.subscribe(
      'results:ui:sort:changed',
      this._boundHandlers.handleSortUpdated,
    )
  }

  unsubscribeFromEvents () {
    window.theme.tagalys.results.eventBus.unsubscribe(
      'results:state:products:updated',
      this._boundHandlers.handleProductsUpdated,
    )
    window.theme.tagalys.results.eventBus.unsubscribe(
      'results:ui:sort:changed',
      this._boundHandlers.handleSortUpdated,
    )
  }

  render () {
    this.lowestCurrentPage = this.state.root.pagination.page
    this.highestCurrentPage = this.state.root.pagination.page

    const helpers = window.theme.tagalys.results.SDK?.helpers
    const hasNextPage = helpers?.hasNextPage?.()
    const hasPreviousPage = helpers?.hasPreviousPage?.()

    switch (this.dataset.type) {
      case 'previous':
        if (hasPreviousPage && this.lowestCurrentPage > 1) {
          this.hidden = false
          this.elements.prevTrigger.dataset.page = String(
            this.lowestCurrentPage - 1,
          )
        } else {
          this.hidden = true
        }
        break
      case 'next':
        if (hasNextPage) {
          this.hidden = false
          this.elements.nextTrigger.dataset.page = String(
            this.highestCurrentPage + 1,
          )
        } else {
          this.hidden = true
        }
        break
      default:
        this.hidden = !hasNextPage && !hasPreviousPage
    }
  }

  set lowestCurrentPage (page) {
    if (page === 0) return
    if (!this._lowestCurrentPage || page < this._lowestCurrentPage) {
      this._lowestCurrentPage = page
    }
  }

  get lowestCurrentPage () {
    return this._lowestCurrentPage || this.state.root.pagination.page - 1
  }

  set highestCurrentPage (page) {
    if (!this._highestCurrentPage || page > this._highestCurrentPage) {
      this._highestCurrentPage = page
    }
  }

  get highestCurrentPage () {
    return this._highestCurrentPage || this.state.root.pagination.page + 1
  }
}

if (!customElements.get('pagination-change')) {
  customElements.define('pagination-change', PaginationChange)
}
